import React, { useState } from 'react';
import axios from 'axios';
import '../App.css'


const Register = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    contact: '',
    address: '',
    dob: '',
    district: '',
    state: '',
    pincode: '',
    password: '',
    confirmPassword: ''
  });
  
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    // Validation
    if (!formData.name || !formData.email || !formData.contact || !formData.password) {
      setError('Name, Email, Contact, and Password are required');
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setError('Please enter a valid email address');
      return;
    }

    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(formData.contact)) {
      setError('Please enter a valid 10-digit contact number');
      return;
    }

    setLoading(true);

    try {
      const data = new FormData();
      
      // Append all form fields
      data.append('name', formData.name);
      data.append('email', formData.email);
      data.append('contact', formData.contact);
      data.append('address', formData.address || '');
      data.append('dob', formData.dob || '');
      data.append('district', formData.district || '');
      data.append('state', formData.state || '');
      data.append('pincode', formData.pincode || '');
      data.append('password', formData.password);
      
      if (image) {
        data.append('image', image);
      }

      console.log('Sending registration request...');
      
      const response = await axios.post('https://theagencybazaar.com/api/Register', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      console.log('Response:', response.data);

      if (response.data.success) {
        setMessage('Registration successful!');
        // Reset form
        setFormData({
          name: '',
          email: '',
          contact: '',
          address: '',
          dob: '',
          district: '',
          state: '',
          pincode: '',
          password: '',
          confirmPassword: ''
        });
        setImage(null);
        if (document.getElementById('imageInput')) {
          document.getElementById('imageInput').value = '';
        }
      } else {
        setError(response.data.error || 'Registration failed');
      }
    } catch (err) {
      console.error('Registration error:', err);
      console.error('Error response:', err.response?.data);
      
      const errorMessage = err.response?.data?.error || 
                          err.response?.data?.message || 
                          err.message || 
                          'Registration failed. Please try again.';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid">
      <div className="row justify-content-center">
        <div className="col-lg-8 col-md-10 col-sm-12">
          <div className="card shadow-sm mt-4">
            <div className="card-header bg-primary text-white">
              <h2 className="mb-0 text-center">Registration Form</h2>
            </div>
            
            <div className="card-body">
              {message && (
                <div className="alert alert-success alert-dismissible fade show" role="alert">
                  ✅ {message}
                  <button type="button" className="btn-close" onClick={() => setMessage('')}></button>
                </div>
              )}
              
              {error && (
                <div className="alert alert-danger alert-dismissible fade show" role="alert">
                  ❌ {error}
                  <button type="button" className="btn-close" onClick={() => setError('')}></button>
                </div>
              )}
              
              <form onSubmit={handleSubmit}>
                {/* First Row */}
                <div className="row mb-3">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="name" className="form-label">
                        <strong>Name *</strong>
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className="form-control"
                        placeholder="Enter your full name"
                      />
                    </div>
                  </div>
                  
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="email" className="form-label">
                        <strong>Email *</strong>
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className="form-control"
                        placeholder="example@email.com"
                      />
                    </div>
                  </div>
                </div>
                
                {/* Second Row */}
                <div className="row mb-3">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="contact" className="form-label">
                        <strong>Contact Number *</strong>
                      </label>
                      <input
                        type="tel"
                        id="contact"
                        name="contact"
                        value={formData.contact}
                        onChange={handleChange}
                        required
                        pattern="[0-9]{10}"
                        title="Please enter a 10-digit phone number"
                        className="form-control"
                        placeholder="1234567890"
                      />
                    </div>
                  </div>
                  
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="dob" className="form-label">
                        <strong>Date of Birth</strong>
                      </label>
                      <input
                        type="date"
                        id="dob"
                        name="dob"
                        value={formData.dob}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
                
                {/* Third Row */}
                <div className="row mb-3">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="district" className="form-label">
                        <strong>District</strong>
                      </label>
                      <input
                        type="text"
                        id="district"
                        name="district"
                        value={formData.district}
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Enter district"
                      />
                    </div>
                  </div>
                  
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="state" className="form-label">
                        <strong>State</strong>
                      </label>
                      <input
                        type="text"
                        id="state"
                        name="state"
                        value={formData.state}
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Enter state"
                      />
                    </div>
                  </div>
                </div>
                
                {/* Fourth Row */}
                <div className="row mb-3">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="pincode" className="form-label">
                        <strong>Pincode</strong>
                      </label>
                      <input
                        type="text"
                        id="pincode"
                        name="pincode"
                        value={formData.pincode}
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Enter pincode"
                      />
                    </div>
                  </div>
                  
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="imageInput" className="form-label">
                        <strong>Profile Image</strong>
                      </label>
                      <input
                        id="imageInput"
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                        className="form-control"
                      />
                      {image && (
                        <small className="text-muted mt-1 d-block">
                          Selected: {image.name}
                        </small>
                      )}
                    </div>
                  </div>
                </div>
                
                {/* Fifth Row - Passwords */}
                <div className="row mb-3">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="password" className="form-label">
                        <strong>Password *</strong>
                      </label>
                      <input
                        type="password"
                        id="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                        minLength="6"
                        className="form-control"
                        placeholder="Enter password (min 6 characters)"
                      />
                    </div>
                  </div>
                  
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="confirmPassword" className="form-label">
                        <strong>Confirm Password *</strong>
                      </label>
                      <input
                        type="password"
                        id="confirmPassword"
                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                        required
                        className="form-control"
                        placeholder="Confirm your password"
                      />
                    </div>
                  </div>
                </div>
                
                {/* Sixth Row - Address (Full width) */}
                <div className="row mb-4">
                  <div className="col-sm-12">
                    <div className="form-group">
                      <label htmlFor="address" className="form-label">
                        <strong>Address</strong>
                      </label>
                      <textarea
                        id="address"
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Enter your complete address"
                        rows="3"
                      />
                    </div>
                  </div>
                </div>
                
                {/* Submit Button */}
                <div className="row">
                  <div className="col-sm-12">
                    <div className="d-grid">
                      <button 
                        type="submit" 
                        disabled={loading}
                        className="btn btn-primary btn-lg"
                      >
                        {loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Registering...
                          </>
                        ) : (
                          'Register Now'
                        )}
                      </button>
                    </div>
                  </div>
                </div>
                
                {/* Required fields note */}
                <div className="row mt-3">
                  <div className="col-sm-12">
                    <small className="text-muted">
                      <span className="text-danger">*</span> Required fields
                    </small>
                  </div>
                </div>
              </form>
            </div>
            
            <div className="card-footer text-center">
              <p className="mb-0">
                Already have an account? <a href="/login" className="text-decoration-none">Login here</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;


